import { render, staticRenderFns } from "./AdminPanel.vue?vue&type=template&id=5178e976"
import script from "./AdminPanel.vue?vue&type=script&lang=js"
export * from "./AdminPanel.vue?vue&type=script&lang=js"
import style0 from "./AdminPanel.vue?vue&type=style&index=0&id=5178e976&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports